{
	"title": "Δηλώσεις",
	"table": {
		"material": "Υλικό",
		"dateOfIssue": "Ημερομηνία έκδοσης",
		"quantity": "Ποσότητα",
		"carbonSavings": "Μειώσεις άνθρακα",
		"status": {
			"title": "Κατάσταση",
			"TransactionProcessing": "Επεξεργασία συναλλαγών",
			"CreatingDeclaration": "Δημιουργία δήλωσης",
			"GenerationFailed": "Η δημιουργία απέτυχε",
			"ReadyToDownload": "Έτοιμο για λήψη"
		}
	},
	"declarationLanguageSelect": {
		"title": "Γλώσσα δήλωσης",
		"description": "Επιλέξτε μια γλώσσα δήλωσης.",
		"label": "Γλώσσα δήλωσης",
		"buttonBack": "Πίσω",
		"buttonSave": "Αποθήκευση"
	},
	"downloadAllLanguageSelect": {
		"title": "Γλώσσες δήλωσης",
		"descriptionGlobal": "Επιλέξτε μια γλώσσα για όλες τις δηλώσεις.",
		"descriptionIndividual": "Ή ορίστε τη γλώσσα για κάθε δήλωση ξεχωριστά.",
		"label": "Γλώσσες δήλωσης",
		"tableHeaderDeclaration": "Δήλωση (υλικό/ημερομηνία έκδοσης)",
		"tableHeaderLanguage": "Γλώσσα δήλωσης",
		"buttonBack": "Πίσω",
		"buttonDownload": "Λήψη δηλώσεων"
	},
	"declarationActions": {
		"changeLanguage": "Αλλαγή γλώσσας δήλωσης",
		"preview": "Προεπισκόπηση",
		"download": "Λήψη",
		"transaction": "Συναλλαγή",
		"showMoreTransactions": "Εμφάνιση περισσότερων συναλλαγών",
		"languageLabel": "Γλώσσα δήλωσης",
		"downloadAll": "Κατεβάστε όλες τις δηλώσεις"
	}
}
